module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'language-ch': _vm.language == 'ch' || _vm.language == 'en'
    },
    attrs: {
      "id": "app"
    }
  }, [_c('app-header', {
    attrs: {
      "language": _vm.language
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "overlay"
  }, [_c('span', {
    on: {
      "click": _vm.closeVideo
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('video', {
    attrs: {
      "id": "myvideo",
      "src": _vm.videoUrl,
      "controls": "",
      "webkit-playsinline": "true",
      "playsinline": "true"
    }
  }, [_vm._v("\n        您的浏览器不支持 video 视屏播放。\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "page-container"
  }, [_c('router-view', {
    ref: "currentPage",
    attrs: {
      "language": _vm.language
    },
    on: {
      "isPlay": _vm.playVideoFn
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bdb756d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 112
// module chunks = 49